import $http from "../axios";

const state = {
  vendings: [],
  vendingBeingManaged: {}
};

const getters = {
  vendings: state => {
    return state.vendings;
  },
  vendingBeingManaged: state => {
    return state.vendingBeingManaged;
  }
};

const actions = {
  getVendings({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `vendings?storeId=${data.storeId}&vendingsList=${data.vendingsList}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_VENDINGS", res.data.payload.vendings);
            commit("POPULATE_CATEGORIES");
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getVending({ commit }, vendingId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`vending?vendingId=${vendingId}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SPECIFIC_VENDINGS", res.data.payload.vending);
            commit(
              "POPULATE_CATEGORIES_SPECIFIC_VENDING",
              res.data.payload.vending._id
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateVending({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-vending`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_VENDING", data.vending);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  addVendingCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`add-vending-category`, {
          categoryId: data.category._id,
          vendingId: data.vendingId
        })
        .then(res => {
          if (res.data.result === "ok") {
            commit("ADD_VENDING_CATEGORY", data);
            commit("POPULATE_CATEGORIES");
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removeVendingCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`remove-vending-category`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("REMOVE_VENDING_CATEGORY", data);
            commit("REMOVE_PRODUCTS_WITH_CATEGORY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  addVendingProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`add-vending-product`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("ADD_VENDING_PRODUCT", {
              ...data,
              product: res.data.payload.product
            });
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removeVendingProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`remove-vending-product`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("REMOVE_VENDING_PRODUCT", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  changeVendingProductCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-vending-product-category`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("CHANGE_VENDING_PRODUCT_CATEGORY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveVendingProducts({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`save-vending-products`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SAVE_UPDATED_PRODUCTS", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getVendingAcDeviceStatus(_, vendingId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-vending-ac-device-status?vendingId=${vendingId}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  resetVendingAcDevicePoe(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`reset-vending-ac-device-poe`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getVendingNamesAndIds() {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-vending-names-and-ids`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  importCatalogFromVending(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`import-catalog-from-vending`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  forceChildrenVendingsPriceUpdate(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`force-children-vendings-price-update`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setVendingBeingManaged({ commit }, vending) {
    commit("SET_VENDING_BEING_MANAGED", vending);
  },

  sendCommandToVending(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`send-command-to-vending`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_VENDINGS(state, vendings) {
    state.vendings = vendings;
  },

  SET_SPECIFIC_VENDINGS(state, vending) {
    const index = state.vendings.findIndex(v => v._id === vending._id);
    state.vendings[index] = vending;
  },

  POPULATE_CATEGORIES(state) {
    for (let i = 0; i < state.vendings.length; i++) {
      let catalogIndex = [];
      for (let j = 0; j < state.vendings[i].catalog.length; j++) {
        catalogIndex[state.vendings[i].catalog[j]._id] = j;
        state.vendings[i].catalog[j].products = [];
      }

      let products = state.vendings[i].products.map(p => {
        p.p /= 100;
        p.v = p.v ? new Date(p.v) : null;
        return p;
      });

      for (let j = 0; j < products.length; j++) {
        if (!isNaN(catalogIndex[products[j].vc])) {
          state.vendings[i].catalog[catalogIndex[products[j].vc]].products.push(
            products[j]
          );
        }
      }
    }
  },

  POPULATE_CATEGORIES_SPECIFIC_VENDING(state, vendingId) {
    const index = state.vendings.findIndex(v => v._id === vendingId);

    let catalogIndex = [];
    for (let j = 0; j < state.vendings[index].catalog.length; j++) {
      catalogIndex[state.vendings[index].catalog[j]._id] = j;
      state.vendings[index].catalog[j].products = [];
    }

    let products = state.vendings[index].products.map(p => {
      p.p /= 100;
      p.v = p.v ? new Date(p.v) : null;
      return p;
    });

    for (let j = 0; j < products.length; j++) {
      if (!isNaN(catalogIndex[products[j].vc])) {
        state.vendings[index].catalog[
          catalogIndex[products[j].vc]
        ].products.push(products[j]);
      }
    }
  },

  UPDATE_VENDING(state, vending) {
    const index = state.vendings.findIndex(v => v._id === vending._id);

    state.vendings[index].vendingInfo.name = vending.vendingInfo.name;
    state.vendings[index].vendingInfo.description =
      vending.vendingInfo.description;
    state.vendings[index].vendingInfo.status = vending.vendingInfo.status;
    state.vendings[index].vendingConfig = vending.vendingConfig;

    state.vendingBeingManaged.vendingInfo.name = vending.vendingInfo.name;
    state.vendingBeingManaged.vendingInfo.description =
      vending.vendingInfo.description;
    state.vendings[index].vendingInfo.status = vending.vendingInfo.status;
    state.vendingBeingManaged.vendingConfig = vending.vendingConfig;
  },

  ADD_VENDING_CATEGORY(state, data) {
    const index = state.vendings.findIndex(v => v._id === data.vendingId);

    state.vendings[index].catalog.push(data.category);

    state.vendingBeingManaged.catalog.push(data.category);
  },

  REMOVE_VENDING_CATEGORY(state, data) {
    const vIndex = state.vendings.findIndex(v => v._id === data.vendingId);

    const cIndex = state.vendings[vIndex].catalog.findIndex(
      c => c._id === data.categoryId
    );

    state.vendings[vIndex].catalog.splice(cIndex, 1);

    state.vendingBeingManaged.catalog.splice(cIndex, 1);
  },

  REMOVE_PRODUCTS_WITH_CATEGORY(state, data) {
    const index = state.vendings.findIndex(v => v._id === data.vendingId);

    state.vendings[index].products = state.vendings[index].products.filter(
      p => {
        return p.vc !== data.categoryId;
      }
    );

    state.vendingBeingManaged.products = state.vendings[index].products;
  },

  ADD_VENDING_PRODUCT(state, data) {
    const vIndex = state.vendings.findIndex(v => v._id === data.vendingId);

    state.vendings[vIndex].products.push(data.product);

    state.vendingBeingManaged.products.push(data.product);

    const cIndex = state.vendings[vIndex].catalog.findIndex(
      c => c._id === data.categoryId
    );

    state.vendings[vIndex].catalog[cIndex].products.push(data.product);

    state.vendingBeingManaged.catalog[cIndex].products.push(data.product);
  },

  UPDATE_VENDING_PRODUCT(state, data) {
    data.product.sl = data.product.sl.map(s => {
      return { ...s, cq: Number(s.cq) };
    });

    let pIndex = state.vendingBeingManaged.products.findIndex(
      p => p.b === data.product.b
    );

    state.vendingBeingManaged.products[pIndex] = data.product;
  },

  REMOVE_VENDING_PRODUCT(state, data) {
    const vIndex = state.vendings.findIndex(v => v._id === data.vendingId);

    let pIndex = state.vendings[vIndex].products.findIndex(
      p => p.b === data.barcode
    );

    state.vendings[vIndex].products.splice(pIndex, 1);

    state.vendingBeingManaged.products.splice(pIndex, 1);

    const cIndex = state.vendings[vIndex].catalog.findIndex(
      c => c._id === data.categoryId
    );

    pIndex = state.vendings[vIndex].catalog[cIndex].products.findIndex(
      p => p.b === data.barcode
    );

    state.vendings[vIndex].catalog[cIndex].products.splice(pIndex, 1);

    state.vendingBeingManaged.catalog[cIndex].products.splice(pIndex, 1);
  },

  CHANGE_VENDING_PRODUCT_CATEGORY(state, data) {
    const vIndex = state.vendings.findIndex(v => v._id === data.vendingId);

    let pIndex = state.vendings[vIndex].products.findIndex(
      p => p.b === data.barcode
    );

    const oldCategory = state.vendings[vIndex].products[pIndex].vc;

    state.vendings[vIndex].products[pIndex].vc = data.categoryId;

    state.vendingBeingManaged.products[pIndex].vc = data.categoryId;

    let cIndex = state.vendings[vIndex].catalog.findIndex(
      c => c._id === data.categoryId
    );

    state.vendings[vIndex].catalog[cIndex].products.push(
      state.vendings[vIndex].products[pIndex]
    );

    state.vendingBeingManaged.catalog[cIndex].products.push(
      state.vendingBeingManaged.products[pIndex]
    );

    cIndex = state.vendings[vIndex].catalog.findIndex(
      c => c._id === oldCategory
    );

    pIndex = state.vendings[vIndex].catalog[cIndex].products.findIndex(
      p => p.b === data.barcode
    );

    state.vendings[vIndex].catalog[cIndex].products.splice(pIndex, 1);

    state.vendingBeingManaged.catalog[cIndex].products.splice(pIndex, 1);
  },

  ADD_SLOT_TO_PRODUCT(state, data) {
    data.slot = {
      ...data.slot,
      cq: Number(data.slot.cq),
      mq: Number(data.slot.mq),
      n: Number(data.slot.n)
    };

    let pIndex = state.vendingBeingManaged.products.findIndex(
      p => p.b === data.product.b
    );

    state.vendingBeingManaged.products[pIndex].sl.push(data.slot);

    state.vendingBeingManaged.products[pIndex].sl.sort((a, b) => a.n - b.n);

    state.vendingBeingManaged.products[
      pIndex
    ].cq = state.vendingBeingManaged.products[pIndex].sl.reduce((t, n) => {
      return t + n.cq;
    }, 0);

    let cIndex = state.vendingBeingManaged.catalog.findIndex(
      c => c._id === state.vendingBeingManaged.products[pIndex].vc
    );

    pIndex = state.vendingBeingManaged.catalog[cIndex].products.findIndex(
      p => p.b === data.product.b
    );

    let sIndex = state.vendingBeingManaged.catalog[cIndex].products[
      pIndex
    ].sl.findIndex(s => s.n === data.slot.n);

    if (sIndex === -1) {
      state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.push(
        data.slot
      );

      state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.sort(
        (a, b) => a.n - b.n
      );
    }

    state.vendingBeingManaged.products[
      pIndex
    ].cq = state.vendingBeingManaged.products[pIndex].sl.reduce(
      (t, n) => t + n.cq,
      0
    );

    state.vendingBeingManaged.catalog[cIndex].products[
      pIndex
    ].cq = state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.reduce(
      (t, n) => {
        return t + n.cq;
      },
      0
    );
  },

  UPDATE_PRODUCT_SLOT(state, data) {
    data.slot = {
      ...data.slot,
      cq: Number(data.slot.cq),
      mq: Number(data.slot.mq),
      n: Number(data.slot.n)
    };

    let pIndex = state.vendingBeingManaged.products.findIndex(
      p => p.b === data.product.b
    );

    state.vendingBeingManaged.products[pIndex].sl[data.slotIndex] = data.slot;

    state.vendingBeingManaged.products[pIndex].sl.sort((a, b) => a.n - b.n);

    let cIndex = state.vendingBeingManaged.catalog.findIndex(
      c => c._id === data.product.vc
    );

    pIndex = state.vendingBeingManaged.catalog[cIndex].products.findIndex(
      p => p.b === data.product.b
    );

    state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl[
      data.slotIndex
    ] = data.slot;

    state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.sort(
      (a, b) => a.n - b.n
    );

    state.vendingBeingManaged.products[
      pIndex
    ].cq = state.vendingBeingManaged.products[pIndex].sl.reduce((t, n) => {
      return t + n.cq;
    }, 0);

    state.vendingBeingManaged.catalog[cIndex].products[
      pIndex
    ].cq = state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.reduce(
      (t, n) => {
        return t + n.cq;
      },
      0
    );
  },

  DELETE_PRODUCT_SLOT(state, data) {
    let pIndex = state.vendingBeingManaged.products.findIndex(
      p => p.b === data.product.b
    );

    let sIndex = state.vendingBeingManaged.products[pIndex].sl.findIndex(
      s => s.n === data.slot.n
    );

    state.vendingBeingManaged.products[pIndex].sl.splice(sIndex, 1);

    let cIndex = state.vendingBeingManaged.catalog.findIndex(
      c => c._id === state.vendingBeingManaged.products[pIndex].vc
    );

    pIndex = state.vendingBeingManaged.catalog[cIndex].products.findIndex(
      p => p.b === data.product.b
    );

    sIndex = state.vendingBeingManaged.catalog[cIndex].products[
      pIndex
    ].sl.findIndex(s => s.n === data.slot.n);

    if (sIndex > -1) {
      state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.splice(
        sIndex,
        1
      );
    }

    state.vendingBeingManaged.products[
      pIndex
    ].cq = state.vendingBeingManaged.products[pIndex].sl.reduce((t, n) => {
      return t + n.cq;
    }, 0);

    state.vendingBeingManaged.catalog[cIndex].products[
      pIndex
    ].cq = state.vendingBeingManaged.catalog[cIndex].products[pIndex].sl.reduce(
      (t, n) => {
        return t + n.cq;
      },
      0
    );
  },

  SAVE_UPDATED_PRODUCTS(state, data) {
    const vIndex = state.vendings.findIndex(v => v._id === data.vendingId);

    state.vendings[vIndex].products = state.vendingBeingManaged.products;

    state.vendings[vIndex].catalog = state.vendingBeingManaged.catalog;
  },

  SET_VENDING_BEING_MANAGED(state, vending) {
    state.vendingBeingManaged = vending;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
